// the regex beast...
/*eslint-disable */
const wiki2html = (function () {
  String.prototype.wiki2html = function (s) {
    s = this;

    // lists need to be done using a function to allow for recusive calls
    function list(str) {
      // (?=[\*#])

      return str.replace(/(?:(?:(?:^|\n)[\*#].*)+)/g, function (m) {
        return list(m.replace(/(^|\n)[\*#][ ]{0,1}/g, ''));
      });
    }

    return list(s
      .replace(/(?:^|\n+)([^# =\*<].+)(?:\n+|$)/gm, function (m, l) {
        if (l.match(/^\^+$/)) {
          return l;
        }
        return "\n<p>" + l + "</p>\n";
      })
      .replace(/(?:^|\n)[ ]{2}(.*)+/g, function (m, l) {
        if (l.match(/^\s+$/)) {
          return m;
        }
        return '<blockquote>' + l + '</blockquote>';
      })
    ).replace(/####/g, '');

  };
}());
/* eslint-enable */

export default wiki2html;
